import React from 'react';
import type { PushPanelExtrasProps } from '../../types';
import { NotionPropertiesEditor } from './NotionPropertiesEditor';

const NotionPushPanelExtras: React.FC<PushPanelExtrasProps> = ({
  provider,
  formValues,
  selectedAction,
  onChange,
  disabled,
  nodeData,
}) => {
  if (provider !== 'notion') return null;

  if (selectedAction === 'create_database_record') {
    const databaseId = formValues.database as string | undefined;
    const properties = (formValues.notionProperties ?? {}) as Record<string, unknown>;

    const handleChange = (value: Record<string, unknown>) => {
      onChange?.('notionProperties', value);
    };

    return (
      <NotionPropertiesEditor
        databaseOrRecordId={databaseId ?? ''}
        isRecordId={false}
        value={properties}
        onChange={handleChange}
        disabled={disabled}
        nodeData={nodeData}
      />
    );
  }

  if (selectedAction === 'update_database_record') {
    const recordId = formValues.record_id as string | undefined;
    const properties = (formValues.notionProperties ?? {}) as Record<string, unknown>;

    const handleChange = (value: Record<string, unknown>) => {
      onChange?.('notionProperties', value);
    };

    return (
      <NotionPropertiesEditor
        databaseOrRecordId={recordId ?? ''}
        isRecordId={true}
        value={properties}
        onChange={handleChange}
        disabled={disabled}
        nodeData={nodeData}
      />
    );
  }

  return null;
};

export default NotionPushPanelExtras;
